<template>
  <div class="zxj-wrap">
    <div class="zxj-top">
      <div class="zxj-top-right">
        <div v-if="doadd" :class="[{ zxjchecked2: clickIndex2 == 0 }]" @click="operation(0)">创建</div>
          <div
          v-if="doupdate"
          :class="[{ zxjchecked2: clickIndex2 == 1 }]"
          @click="operation(1)"
        >
          修改
        </div>
        <div
          v-if="isShow1==true"
          :class="[{ zxjchecked2: clickIndex2 == 5 }]"
          @click="operation(5)"
        >允许开票</div>
        <div
          v-if="isShow1==false"
          :class="[{ zxjchecked2: clickIndex2 == 6 }]"
          @click="operation(6)"
        >取消开票</div>

        <div
          v-if="isShow==true"
          :class="[{ zxjchecked2: clickIndex2 == 3 }]"
          @click="operation(3)"
        >显示</div>
        <div
          v-if="isShow==false"
          :class="[{ zxjchecked2: clickIndex2 == 4 }]"
          @click="operation(4)"
        >隐藏</div>
      
        <!-- <div
          v-if="dodelete"
          :class="[{ zxjchecked2: clickIndex2 == 2 }]"
          @click="operation(2)"
        >
          删除
        </div>-->
      </div>
    </div>
    <div class="zxj-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="zxj-con-wrap">
          <div class="zxj-con-title">
            <div>序号</div>
            <div>编码</div>
            <div>助记码</div>
            <div>账项图标</div>
            <div>账项名称</div>
            <div style="flex:2">英文</div>
            <div>账项类别</div>
            <div>付款类别</div>
            <div>开票</div>
            <div>利润点</div>
            <!-- <div>前台</div>
            <div>POS</div>
            <div>AR</div>
            <div>预订金</div>
            <div>类别</div>-->
            <div>显示</div>
            <div>顺序</div>
          </div>
          <div class="zxj-con-contaniner">
            <transition-group name="list">
              <div 
                :class="['zxj-con-item', { zxjchecked: zxjIndex == index }]"
                v-for="(item, index) in list"
                :key="item.iid"
               
                @dblclick="updata(index)"
                @click="chooseRy(index)"
              >
                <div>{{ index + 1 }}</div>
                <div>{{ item.ccode }}</div>
                <div>{{ item.cmcode }}</div>
                <div>
                  <img v-if="item.ccode == 992" class="logoimg" src="../assets/image/zfbzf.png" />
                  <img v-else-if="item.ccode == 993" class="logoimg" src="../assets/image/wxzf.png" />
                </div>
                <div>{{ item.cchnname }}</div>
                <div style="flex:2">{{ item.cengname }}</div>
                <div>{{ item.cacccodename }}</div>
                <div>{{ item.cpaytypename }}</div>
                <div v-if="item.iinvoice == 0">不允许</div>
                <div v-else-if="item.iinvoice ==1">允许</div>
                <div v-else>未知</div>
                <div>{{ item.cprofitpoint }}</div>

                <!-- <div v-if="item.ifront == 0">否</div>
                <div v-else-if="item.ifront == 1">允许</div>
                <div v-else></div>
                <div v-if="item.ipos == 0">否</div>
                <div v-else-if="item.ipos == 1">允许</div>
                <div v-else></div>
                <div v-if="item.iar == 0">否</div>
                <div v-else-if="item.iar == 1">允许</div>
                <div v-else></div>
                <div v-if="item.iadvance == 0">否</div>
                <div v-else-if="item.iadvance == 1">允许</div>
                <div v-else></div>
                <div v-if="item.isort == 0">否</div>
                <div v-else-if="item.isort == 1">允许</div>
                <div v-else></div>-->
                <div v-if="item.isyshold == 0">否</div>
                <div v-else-if="item.isyshold == 1">是</div>
                <div v-else></div>
                <div>{{ item.idisporder }}</div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 

<script>
import { getRequest, postRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      list: [],
      dosee: false,
      doadd: false,
      doupdate: false,
      dodelete: false,
      isShow: null,
      isShow1: null
    };
  },
  computed: {
    zxjIndex() {
      return this.$store.state.zhangxiangjIndex2;
    },
    clickIndex2() {
      return this.$store.state.operationIndex6;
    }
  },
  watch: {
    "$store.state.tFinanceAccountsItemD": function(val) {
      
      if (val == false) {
        this.getData();
      }
    }
  },
  created() {
    this.dosee = this.power.checkedpower("0604001");
    this.doadd = this.power.checkedpower("0604000");
    this.doupdate = this.power.checkedpower("0604002");
    this.dodelete = this.power.checkedpower("0604003");

    if (this.dosee == false) {
      this.$router.push("/power");
    }
    this.getData();
  },

  methods: {
    getData() {
      this.$store.state.zhangxiangjIndex2 = null;
      if (this.$store.state.tFinanceAccountsItemD.length > 0) {
        let result = this.$store.state.tFinanceAccountsItemD;
        this.list = result;
      } else {
        let loadingInstance = this.$loading({
          text: "加载中"
        });
        getRequest(
          "/tFinanceAccountsItem/selectAll?hotelId=" +
            localStorage.getItem("ihotelid")
        ).then(res => {
          
          this.$nextTick(() => {
            loadingInstance.close();
          });
          if (res.status == 200) {
            let result = res.data;
            let result2 = result.filter(function(item) {
              return item.idebit == 1;
            });
            this.list = result2;
            this.$store.state.tFinanceAccountsItemD = result2;
          } else {
            this.$mymessage({
              content: res.message,
              type: "error",
              time: 3000,
              hasClose: true
            });
          }
        });
      }
    },
    operation(index) {
      let that = this;
      
      if (index == 0) {
        this.$store.state.operationIndex6 = index;
        let num = 0;
        if (this.$store.state.tFinanceAccountsItemD.length > 0) {
          num = this.$store.state.tFinanceAccountsItemD[
            this.$store.state.tFinanceAccountsItemD.length - 1
          ].idisporder;
        }

        let obj = {
          operation: "创建",
          status: 0,
          name: "贷方账项",
          ifront: 0,
          ipos: 0,
          iar: 0,
          iadvance: 0,
          isort: 0,
          isyshold: 0,
          idebit: 1,
          idisporder: ++num
        };
        this.$zhangxiang({ obj });
      } else if (index == 1) {
        if (this.$store.state.zhangxiangjIndex2 != null) {
          let obj = JSON.parse(
            JSON.stringify(
              this.$store.state.tFinanceAccountsItemD[
                this.$store.state.zhangxiangjIndex2
              ]
            )
          );

          this.$store.state.operationIndex6 = index;

          obj.operation = "修改";
          obj.name = "贷方账项";
          obj.zhangxiangjIndex = this.$store.state.zhangxiangjIndex2;
          this.$zhangxiang({ obj });
        } else {
          this.$mymessage({
            content: "请选择修改内容",
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      } else if (index == 2) {
        if (this.$store.state.zhangxiangjIndex2 != null) {
          let obj = JSON.parse(
            JSON.stringify(
              this.$store.state.tFinanceAccountsItemD[
                this.$store.state.zhangxiangjIndex2
              ]
            )
          );
          this.$store.state.operationIndex6 = index;

          obj.title = "删除";
          obj.message = "您确定要删除吗";
          obj.zhangxiangjIndex2 = this.$store.state.zhangxiangjIndex2;

          this.$confirm({ obj });
        } else {
          this.$mymessage({
            content: "请选择删除内容",
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      } else if (index == 3) {
        let obj = JSON.parse(
          JSON.stringify(
            this.$store.state.tFinanceAccountsItemD[
              this.$store.state.zhangxiangjIndex2
            ]
          )
        );
        
        obj.isyshold = 1;
        postRequest(
          "/tFinanceAccountsItem/updateTFinanceAccountsItem",
          obj
        ).then(res => {
          
          if (res.status == 200) {
            that.$store.state.tFinanceAccountsItemD.splice(
              that.$store.state.zhangxiangjIndex2,
              1,
              res.data
            );
            that.isShow = false;

            that.$mymessage({
              content: "修改成功",
              type: "success",
              time: 2000,
              hasClose: true
            });
          } else {
            that.$mymessage({
              content: res.message,
              type: "error",
              time: 2000,
              hasClose: true
            });
          }
        });
      } else if (index == 4) {
        let obj = JSON.parse(
          JSON.stringify(
            this.$store.state.tFinanceAccountsItemD[
              this.$store.state.zhangxiangjIndex2
            ]
          )
        );
        
        obj.isyshold = 0;
        postRequest(
          "/tFinanceAccountsItem/updateTFinanceAccountsItem",
          obj
        ).then(res => {
          
          if (res.status == 200) {
            that.$store.state.tFinanceAccountsItemD.splice(
              that.$store.state.zhangxiangjIndex2,
              1,
              res.data
            );
            that.isShow = true;

            that.$mymessage({
              content: "修改成功",
              type: "success",
              time: 2000,
              hasClose: true
            });
          } else {
            that.$mymessage({
              content: res.message,
              type: "error",
              time: 2000,
              hasClose: true
            });
          }
        });
      } else if (index == 5) {
        if (this.$store.state.zhangxiangjIndex2 == null) {
          return;
        }
        let obj = JSON.parse(
          JSON.stringify(
            this.$store.state.tFinanceAccountsItemD[
              this.$store.state.zhangxiangjIndex2
            ]
          )
        );
        
        obj.iinvoice = 1;
        postRequest(
          "/tFinanceAccountsItem/updateTFinanceAccountsItem",
          obj
        ).then(res => {
          
          if (res.status == 200) {
            that.$store.state.tFinanceAccountsItemD.splice(
              that.$store.state.zhangxiangjIndex2,
              1,
              res.data
            );
            that.isShow1 = false;

            that.$mymessage({
              content: "修改成功",
              type: "success",
              time: 2000,
              hasClose: true
            });
            that.chooseRy(that.$store.state.zhangxiangjIndex2);
          } else {
            that.$mymessage({
              content: res.message,
              type: "error",
              time: 2000,
              hasClose: true
            });
          }
        });
      } else if (index == 6) {
        if (this.$store.state.zhangxiangjIndex2 == null) {
          return;
        }
        let obj = JSON.parse(
          JSON.stringify(
            this.$store.state.tFinanceAccountsItemD[
              this.$store.state.zhangxiangjIndex2
            ]
          )
        );
        
        obj.iinvoice = 0;
        postRequest(
          "/tFinanceAccountsItem/updateTFinanceAccountsItem",
          obj
        ).then(res => {
          
          if (res.status == 200) {
            that.$store.state.tFinanceAccountsItemD.splice(
              that.$store.state.zhangxiangjIndex2,
              1,
              res.data
            );
            that.isShow1 = true;

            that.$mymessage({
              content: "修改成功",
              type: "success",
              time: 2000,
              hasClose: true
            });
            that.chooseRy(that.$store.state.zhangxiangjIndex2);
          } else {
            that.$mymessage({
              content: res.message,
              type: "error",
              time: 2000,
              hasClose: true
            });
          }
        });
      }
    },
    chooseRy(index) {
      this.$store.state.zhangxiangjIndex2 = index;
      let item = this.list[index];
      
      if (item.isyshold == 1) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      if (item.iinvoice == 1) {
        this.isShow1 = false;
      } else {
        this.isShow1 = true;
      }
    },
    updata(index){
      this.chooseRy(index);
      this.operation(1);
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.zxj-wrap {
  width: 102%;
  margin-left: -1%;
  height: 100%;
  z-index: 999;
  position: relative;
  overflow: hidden;
}
.zxj-top {
  width: 100%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2%;
}

.zxj-top-right div {
  width: 6em;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 0 10px;
  cursor: pointer;
}

.zxjchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.zxj-top-right {
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.zxj-container {
  width: 100%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
}
.zxj-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.zxj-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  overflow: hidden;
}
.zxj-con-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.zxj-con-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
  width: 99%;
}
.zxj-con-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  flex:1
}

.zxj-con-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: overlay;
}
.zxj-con-item {
  display: flex;
  width: 100%;
  border: 1px solid transparent;
  cursor: pointer;
  width: 99%;
}
.zxj-con-item div {
  text-align: center;
  line-height: 3em;
  flex:1;
  white-space: nowrap;
  overflow: hidden;
}

.zxj-con-contaniner .zxjchecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.logoimg {
  width: 20px !important;
  height: 20px !important;
  position: relative !important;
}
</style>